import styled from 'styled-components';
import {DashboardHeader} from 'components/DashboardHeader/styles';

export const IABActiveStateHeader = styled(DashboardHeader)`
  margin-bottom: 20px;
`;

const IABButtonBase = styled.button`
  display: inline-block;
  position: relative;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 1;
  color: #fff;
  border-radius: 30px;
  padding: 19px 20px;
  border: none;
  outline: none;
  cursor: pointer;
  overflow: hidden;
  transition-property: background-color;
  transition-duration: 0.3s;

  &.ButtonMedium {
    font-size: 14px;
    padding: 16px 26px;
  }
`;

export const IABButtonYellow = styled(IABButtonBase)`
  background-color: #fca600;
  padding: 0 24px !important;
  &:hover {
    background-color: #db9000;
  }
  span {
    line-height: 28px;
    font-size: 13px;
  }
`;

export const IABActiveBanner = styled.section`
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: #e3fff4;
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 24px;
`;

export const IABActiveBannerIcon = styled.img`
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  object-fit: contain;
`;

export const IABActiveBannerTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
  color: #2f3d48;
`;

export const IABActiveBannerText = styled.div`
  margin-top: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #2f3d48;
  line-height: 1.5;
  strong {
    font-weight: 700;
  }
`;

export const IABDiscountCard = styled.section`
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
`;

export const IABDiscountColumn = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  float: left;
  margin-right: 48px;
  @media (max-width: 900px) {
    float: none;
    margin-right: 0;
    margin-bottom: 24px;
  }
`;

export const IABDiscountValue = styled.div`
  font-size: 64px;
  font-weight: 700;
  color: #2f3d48;
  line-height: 0;
`;

export const IABDiscountLabel = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #2f3d48;
  margin-bottom: 10px;
`;

export const IABDiscountTierBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  &.below {
    color: #fca600;
  }
  &.best {
    color: #17c981;
  }
  &.top {
    color: #8b5cf6;
  }
`;

export const IABDiscountTierIcon = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
`;

export const IABDiscountCompare = styled.div`
  overflow: hidden;
`;

export const IABBenchmarkBar = styled.div`
  display: flex;
  border-radius: 8px;
  overflow: hidden;
`;

export const IABBenchmarkSegment = styled.div`
  padding: 3px 12px;
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  color: #2f3d48;
  &.below {
    flex: 2 1 0;
    background-color: #e3fff4;
  }
  &.best {
    flex: 1 1 0;
    background-color: #fff6e5;
  }
  &.top {
    flex: 2 1 0;
    background-color: #ecf1fb;
  }
`;

export const IABDiscountAlertWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 90px;
  width: 100%;
  background-color: #fff6e5;
  padding: 15px 16px 18px 20px;
  margin-top: 40px;
  border-radius: 8px;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

export const IABDiscountAlert = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  background-color: #fff6e5;
  border-radius: 8px;
  clear: both;
  @media (max-width: 900px) {
    flex-direction: row;
    align-items: stretch;
  }
`;

export const IABDiscountAlertIcon = styled.img`
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

export const IABDiscountAlertTextBlock = styled.div`
  flex: 1 1 auto;
`;

export const IABDiscountAlertTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
  color: #2f3d48;
`;

export const IABDiscountAlertText = styled.div`
  margin-top: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #2f3d48;
  line-height: 1.5;
`;

export const IABDiscountAlertButton = styled(IABButtonYellow)`
  min-width: 146px;
  height: 28px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IABMetricsFunnelGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(360px, 1.4fr);
  gap: 24px;
  margin-top: 24px;
  align-items: stretch;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const IABMetricsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const IABMetricGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(300px, calc((100% - 24px) / 2)));
  gap: 24px;
  margin-top: 24px;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const IABMetricCard = styled.section`
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px 20px 9px;
`;

export const IABMetricTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const IABMetricContentRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 30px;
`;

export const IABMetricIcon = styled.img`
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  object-fit: contain;
`;

export const IABMetricTextBlock = styled.div`
  flex: 1 1 auto;
`;

export const IABMetricLabel = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0;
  color: #2f3d48;
`;

export const IABMetricValue = styled.div`
  font-size: 42px;
  font-weight: 275;
  color: #2f3d48;
  line-height: 1.5;
  letter-spacing: 0;
`;

export const IABMetricSubtext = styled.div`
  flex: 1 1 auto;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0;
  text-align: right;
  color: #b3b9c2;
`;

export const IABFunnelCard = styled.section`
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
`;

export const IABFunnelTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  color: #2f3d48;
`;

export const IABFunnelSubtitle = styled.div`
  margin-top: 8px;
  font-size: 12px;
  font-weight: 400;
  color: #000000;
  line-height: 1.5;
`;

export const IABFunnelRow = styled.div`
  margin-top: 18px;
`;

export const IABFunnelLabelRow = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr auto auto;
  align-items: center;
  gap: 12px;
  margin-bottom: 6px;
`;

export const IABFunnelIcon = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

export const IABFunnelLabel = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #000000;
  line-height: 1.5;
`;

export const IABFunnelValues = styled.div`
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
`;

export const IABFunnelBar = styled.div`
  height: 17px;
  border-radius: 8px;
  background-color: #f7f7f7;
  overflow: hidden;
`;

export const IABFunnelBarFill = styled.div`
  height: 100%;
  border-radius: 8px;
  background-color: #17c981;
  transition: width 0.3s ease-in-out;
`;

export const IABFunnelCount = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #000000;
  line-height: 1.5;
  min-width: 24px;
  text-align: right;
`;

export const IABFunnelPercent = styled.div`
  font-size: 10px;
  font-weight: 700;
  color: #b3b9c2;
  line-height: 1.5;
  min-width: 28px;
  text-align: right;
`;
